<template>
  <div id="side-bar" ref="sidebar" class="c-sidebar" :class="{'little': isClose}">
    <div class="logo-wrap" :class="{'mini': isClose}">
      <img :src="!isClose ? imgLogo : imgLogoMini" alt="">
    </div>
    <div class="links">
      <span v-for="(link, index) in links" :key="index" class="link-wrapper">
        <n-link
          v-show="isShow(link.permissions, link.condition) &&
            (link.name === 'organizations' ? user.company?.successCard === 'bazis' : true)"
          class="link" :to="!!link.child ? '': {name: link.name}"
          :class="{'active': isActive(link.name), 'withChild': link.child?.length > 0}"
          @click="link.child?.length > 0 ? openLink(link.name) : ''">
          <div class="mark"></div>
          <div class="title-wrap">
            <div class="image-place">
              <img v-if="isActive(link.name)" :src="link.iconActive" alt="">
              <img v-else :src="link.icon" alt="">
            </div>
            <div v-if="!isClose" class="title">{{ link.title }}</div>
            <div v-if="link.child?.length > 0" class="image-place child-row">
              <img :src="isActive(link.name) ? childRowActive : childRow" alt="">
            </div>
          </div>
        </n-link>
        <span v-show="link.child?.length > 0 && openedLink === link.name" class="sub-link-wrapper">
          <n-link
            v-for="(child, i) in link.child"
            v-show="isShow(child.permissions, child.condition) "
            :key="i"
            class="link" :to="{name: child.name}"
            :class="{'active': isActive(child.name)}">
            <div class="mark"></div>
            <div class="title-wrap">
              <div class="image-place">
                <img v-if="isActive(child.name)" :src="child.iconActive" alt="">
                <img v-else :src="child.icon" alt="">
              </div>
              <div v-if="!isClose" class="title">{{ child.title }}</div>
            </div>
          </n-link>
        </span>
      </span>
    </div>
    <div class="image-close" :class="{'closed': isClose}">
      <img :src="imgClose" alt="" @click="isClose = !isClose" />
    </div>
  </div>
</template>

<script>
import imgProfile from 'assets/menu/UserCircle.svg'
import imgNoLogo from 'assets/no-logo-icon.svg'
import imgToProfile from 'assets/menu/gear-solid(1).svg'
import imgLogout from 'assets/menu/right-from-bracket-solid(1).svg'
import imgList from 'assets/menu/List.svg'
import imgLocPoint from 'assets/menu/qrcode-solid.svg'
// import imgBranches from 'assets/menu/location-dot-solid.svg'
import imgStar from 'assets/menu/address-card-solid.svg'
import imgLogo from 'assets/logo-icon.svg'
import imgLogoMini from 'assets/mini-logo-icon.png'
import imgStats from 'assets/sidebar-icons/stats-icon.svg'
import imgStatsActive from 'assets/sidebar-icons/stats-icon-active.svg'
import imgTimesheet from 'assets/sidebar-icons/timesheet-icon.svg'
import imgTimesheetActive from 'assets/sidebar-icons/timesheet-icon-active.svg'
import imgBranches from 'assets/sidebar-icons/branches-icon.svg'
import imgBranchesActive from 'assets/sidebar-icons/branches-icon-active.svg'
import imgOrganizations from 'assets/sidebar-icons/organizations-icon.svg'
import imgOrganizationsActive from 'assets/sidebar-icons/organizations-icon-active.svg'
import imgDepartments from 'assets/sidebar-icons/departments-icon.svg'
import imgDepartmentsActive from 'assets/sidebar-icons/departments-icon-active.svg'
import imgEmployees from 'assets/sidebar-icons/employees-icon.svg'
import imgEmployeesActive from 'assets/sidebar-icons/employees-icon-active.svg'
import imgApplications from 'assets/sidebar-icons/applications-icon.svg'
import imgApplicationsActive from 'assets/sidebar-icons/applications-icon-active.svg'
import imgPoints from 'assets/sidebar-icons/point-icon.svg'
import imgPointsActive from 'assets/sidebar-icons/point-icon-active.svg'
import imgSchedule from 'assets/sidebar-icons/schedule-icon.svg'
import imgScheduleActive from 'assets/sidebar-icons/schedule-icon-active.svg'
import imgPositions from 'assets/sidebar-icons/positions-icon.svg'
import imgPositionsActive from 'assets/sidebar-icons/positions-icon-active.svg'
import imgNotifications from 'assets/sidebar-icons/notifications-icon.svg'
import imgNotificationsActive from 'assets/sidebar-icons/notifications-icon-active.svg'
import imgClose from '../../assets/new/close-sidebar-icon.svg'
import imgFinance from 'assets/sidebar-icons/finance-icon.svg'
import imgFinanceActive from 'assets/sidebar-icons/finance-icon-active.svg'
import imgExports from 'assets/sidebar-icons/exports-icon.svg'
import imgExportsActive from 'assets/sidebar-icons/exports-icon-active.svg'

import childRow from 'assets/sidebar-icons/with-child-row.svg'
import imgSupport from '../../assets/sidebar-icons/support-icon.svg'
import imgSupportActive from '../../assets/sidebar-icons/support-icon-active.svg'
import childRowActive from 'assets/sidebar-icons/with-child-row-active.svg'

import imgFines from 'assets/sidebar-icons/fines.svg'
import imgFinesActive from 'assets/sidebar-icons/finesActive.svg'
import imgFinanceStats from 'assets/sidebar-icons/financeStats.svg'
import imgFinanceStatsActive from 'assets/sidebar-icons/financeStatsActive.svg'
import imgSettings from 'assets/sidebar-icons/settings-icon.svg'
import imgSettingsActive from 'assets/sidebar-icons/settings-icon-active.svg'
import imgMood from 'assets/sidebar-icons/smile-icon.svg'
import imgMoodActive from 'assets/sidebar-icons/smile-icon-active.svg'


export default {
  name: 'CSidebar',
  data() {
    return {
      links: [
        {
          name: 'timesheet',
          permissions: [ 'users_get', ],
          title: 'Табель',
          icon: imgTimesheet,
          iconActive: imgTimesheetActive,
        },
        {
          name: 'stats',
          permissions: [ 'users_get', ],
          title: 'Статистика',
          icon: imgStats,
          iconActive: imgStatsActive,
        },
        {
          name: 'tgStats',
          permissions: [ 'users_get', ],
          title: 'TG Статистика',
          icon: imgStats,
          iconActive: imgStatsActive,
        },
        {
          name: 'users',
          permissions: [ 'users_get', ],
          title: 'Сотрудники',
          icon: imgEmployees,
          iconActive: imgEmployeesActive,
        },
        {
          name: 'scheduleTemplates',
          permissions: [ 'scheduleTemplates_get', ],
          title: 'Расписания',
          icon: imgSchedule,
          iconActive: imgScheduleActive,
        },
        {
          name: 'departments',
          permissions: [ 'departments_get', ],
          title: 'Отделы',
          icon: imgDepartments,
          iconActive: imgDepartmentsActive,
        },
        {
          name: 'positions',
          permissions: [ 'positions_get', ],
          title: 'Должности',
          icon: imgPositions,
          iconActive: imgPositionsActive,
        },
        {
          name: 'index',
          permissions: [ 'branches_get', 'branches_getAll', ],
          title: 'Филиалы',
          icon: imgBranches,
          iconActive: imgBranchesActive,
        },
        {
          name: 'locationPoints',
          permissions: [ 'branches_get', 'branches_getAll', ],
          title: 'Точка контроля',
          icon: imgPoints,
          iconActive: imgPointsActive,
        },
        {
          name: 'organizations',
          permissions: [ 'organizations_get', ],
          title: 'Организации',
          icon: imgOrganizations,
          iconActive: imgOrganizationsActive,
        },
        {
          name: 'financial',
          permissions: [ 'salaries_get', ],
          title: 'Финансы',
          icon: imgFinance,
          iconActive: imgFinanceActive,
          child: [
            {
              name: 'finances',
              permissions: [ 'salaries_get', ],
              title: 'Расчет зарплаты',
              icon: imgFinanceStats,
              iconActive: imgFinanceStatsActive,
            },
            {
              name: 'finesRewards',
              permissions: [ 'salaries_get', ],
              title: 'Штрафы и награды',
              icon: imgFines,
              iconActive: imgFinesActive,
            },
          ],
        },
        {
          name: 'applications',
          permissions: [ 'requests_get', ],
          title: 'Запросы',
          icon: imgApplications,
          iconActive: imgApplicationsActive,
        },
        {
          name: 'moods',
          title: 'Настроение',
          icon: imgMood,
          iconActive: imgMoodActive,
        },
        {
          name: 'notifications',
          permissions: [ 'users_get', ],
          title: 'Уведомления',
          icon: imgNotifications,
          iconActive: imgNotificationsActive,
        },
        {
          name: 'exports',
          permissions: null,
          title: 'Экспорты',
          icon: imgExports,
          iconActive: imgExportsActive,
        },
        {
          name: 'support',
          permissions: null,
          title: 'Поддержка',
          icon: imgSupport,
          iconActive: imgSupportActive,
        },
        {
          name: 'settingsTemplates',
          permissions: [ 'settingsTemplates_attach', 'settingsTemplates_create', ],
          title: 'Настройки',
          icon: imgSettings,
          iconActive: imgSettingsActive,
        },
      ],
      imgSettings,
      imgSettingsActive,
      imgExports,
      imgExportsActive,
      imgProfile,
      imgLogoMini,
      imgList,
      imgToProfile,
      imgLogout,
      imgLocPoint,
      imgStar,
      imgClose,
      imgFinance,
      imgFinanceActive,
      childRow,
      childRowActive,
      imgFines,
      imgFinesActive,
      imgFinanceStats,
      imgFinanceStatsActive,
      imgSupportActive,
      imgSupport,
      open: false,
      isClose: false,
      user: {},
      imgNoLogo,
      imgLogo,
      imgStats,
      imgStatsActive,
      imgTimesheet,
      imgTimesheetActive,
      imgBranches,
      imgBranchesActive,
      imgOrganizations,
      imgOrganizationsActive,
      imgDepartments,
      imgDepartmentsActive,
      imgEmployees,
      imgEmployeesActive,
      imgApplications,
      imgApplicationsActive,
      imgPoints,
      imgPointsActive,
      imgSchedule,
      imgScheduleActive,
      imgPositions,
      imgPositionsActive,
      imgNotifications,
      imgNotificationsActive,
      imgMoodActive,
      imgMood,
      showOrganization: false,
      openedLink: '',
    }
  },
  computed: {
    route() {
      return this.$route.name
    },
  },
  watch: {
    isClose() {
      this.$emit('update:isSlide', this.isClose)
    },
  },
  created() {
    this.getCompany()
  },
  methods: {
    isShow(permissions, other) {
      let show = true
      if (permissions) {
        show = false
        $n.each(permissions, (e) => {
          if (!show) {
            show = $app.auth.can(e)
          }
        })
      }
      if (other) {
        show = other
      }
      return show
    },
    openLink(name) {
      if (this.openedLink === name) {
        this.openedLink = ''
      } else {
        this.openedLink = name
      }
    },
    isActive(name) {
      if (name === 'index') {
        return [ 'index', 'branch', ].includes(this.route)
      }
      if (name === 'exports') {
        return [ 'exports', ].includes(this.route)
      }
      if (name === 'tgStats') {
        return [ 'tgStats', ].includes(this.route)
      }
      if (name === 'support') {
        return [ 'support', ].includes(this.route)
      }
      if (name === 'settingsTemplates') {
        return [ 'settingsTemplates', 'settingsTemplate', ].includes(this.route)
      }
      if (name === 'applications') {
        return [ 'applications', ].includes(this.route)
      }
      if (name === 'financial') {
        return [ 'finances', 'finesRewards', ].includes(this.route)
      }
      if (name === 'finances') {
        return [ 'finances', ].includes(this.route)
      }
      if (name === 'finesRewards') {
        return [ 'finesRewards', ].includes(this.route)
      }
      if (name === 'notifications') {
        return [ 'notifications', 'notificationsAdd', ].includes(this.route)
      }
      if (name === 'locationPoints') {
        return [ 'locationPoints', 'locationPoint', ].includes(this.route)
      }
      if (name === 'positions') {
        return [ 'position', 'positions', ].includes(this.route)
      }
      if (name === 'scheduleTemplates') {
        return [ 'scheduleTemplates', 'scheduleTemplate', ].includes(this.route)
      }
      if (name === 'departments') {
        return [ 'departments', 'department', ].includes(this.route)
      }
      if (name === 'applicationTemplates') {
        return [ 'applicationTemplates', 'applicationTemplate', ].includes(this.route)
      }
      if (name === 'timesheet') {
        return this.route === 'timesheet'
      }
      if (name === 'users') {
        return [ 'users', 'user', ].includes(this.route)
      }
      if (name === 'stats') {
        return this.route === 'stats'
      }
      if (name === 'checklists') {
        return [ 'checklists', 'checklist', ].includes(this.route)
      }
      if (name === 'organizations') {
        return [ 'organizations', 'organization', ].includes(this.route)
      }
      if (name === 'moods') {
        return [ 'moods', ].includes(this.route)
      }
    },
    getCompany() {
      this.$var('load', true)
      const query = 'with[company][with][settings]&with[company][with][integrations]'
      $api.auth.info().query(query).then((response) => {
        this.user = response.data.content.user

        $app.auth.grants(response.data.content.grants)
        $app.auth.user(this.user)
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-sidebar {
  width: 270px;
  padding: 0 20px 20px 0;
  transition: 0.3s;
  height: 106dvh;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: sticky;
  top: 0;

  .links {
    flex: 1 1 auto;   /* растягиваем на всё оставшееся место */
    min-height: 0;    /* критично для корректной работы overflow во flex-контейнере */
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  @media (-webkit-device-pixel-ratio: 1.25) and (max-height: 870px) {
    height: calc(100dvh * 0.95);
    zoom: 70%;
  }
  @media (-webkit-device-pixel-ratio: 2) and (max-height: 1440px) {
    zoom: 90%;
  }

  @media (width: 1920px) and (-webkit-device-pixel-ratio: 1) {
    zoom: 90%;
  }
  @media (max-width: 1380px) {
    height: auto;
  }

  .logo-wrap {
    width: 220px;
    height: 110px;
    transition: 0.3s;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &.little {
    width: 90px;
    padding: 0 0 50px 0;
    transition: 0.3s;

    .link {
      width: 90px;
      transition: 0.5s;

      &.active {
        .image-place {
          margin-left: 5px;
        }
      }
    }

    .logo-wrap {
      width: 100%;
      transition: 0.3s;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 5px;

      img {
        width: 60px;
        height: 60px;
        object-fit: contain;
      }
    }
  }

  .link {
    display: flex;
    align-items: center;
    height: 55px;
    flex-shrink: 0;
    width: 250px;

    .mark {
      width: 6px;
      height: 100%;
      background: #fff;
      border-radius: 0 10px 10px 0;
    }

    .title-wrap {
      display: flex;
      align-items: center;
      margin-left: 30px;

      .image-place {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        min-width: 24px;
        min-height: 24px;
        max-width: 28px;
        max-height: 28px;
        transition: 1s;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        &.child-row {
          min-width: 18px;
          min-height: 18px;
          max-width: 18px;
          max-height: 18px;
          margin-left: 10px;
        }
      }

      .title {
        color: #B1B1B1;
        font-size: 17px;
        font-weight: 500;
        margin-left: 15px;
      }
    }

    &.active {

      .image-place {
        margin-left: 10px;
      }

      .mark {
        background: var(--primary);
      }

      .title {
        color: var(--primary);
      }
    }
    &.withChild {
      .image-place {
        margin-left: 0;
      }
    }

  }

  .image-close {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    transition: 0.5s;
    margin-left: 10px;
    margin-top: 10px;

    &.closed {
      transform: rotate(180deg);
      transition: 0.5s;
    }
  }


  .sub-link-wrapper {
    .link {
      .title-wrap {
        margin-left: 45px;
      }
    }
  }
}
</style>
